


















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ConfirmDialog extends Vue {
  @Prop({ default: 'cancel' }) actionCancel!: string
  @Prop({ default: 'confirm' }) actionConfirm!: string
  @Prop({ default: undefined }) item!: any
  @Prop({ default: 'Are you sure?' }) title!: string

  onCancelClicked () {
    this.$emit('cancel', this.item)
  }

  onConfirmClicked () {
    this.$emit('confirm', this.item)
  }
}
